import styled from 'styled-components';
import { rem } from 'polished';

const ConversionContainer = styled.div`
    margin-top: ${rem(16)};
`;

export default ConversionContainer;
